import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormFieldBase } from '@modules/creator/components/forms/form-field/form-field-base';

@Component({
  selector: '[checkbox-field]',
  styles: [`
    mat-form-field {
      width: 100%;
    }

    mat-checkbox, .mat-mdc-checkbox label, .mat-mdc-checkbox .mat-internal-form-field {
      font-family: inherit !important;
      font-size: inherit !important;
      line-height: inherit !important;
      letter-spacing: inherit !important;
      font-kerning: inherit !important;
      font-weight: inherit !important;
      text-transform: inherit !important;
      color: inherit !important;
      font-style: inherit !important;
      text-decoration: inherit !important;
      text-shadow: inherit !important;
      text-align: inherit !important;
    }

    mat-error.checkbox-error {
      padding-left: 25px;
    }
  `],
  template: `
    <div [formGroup]="formGroup">
      <mat-checkbox [formControlName]="formName"
                    [aria-label]="item.content || null"
                    [tabIndex]="item.tabindex"
                    (keyup)="onKey($event)"
                    [required]="required"
                    (ngModelChange)="dataChanged($event)"
                    (keydown.enter)="toggleFromEnter($event)"
      >{{ item.content }}
      </mat-checkbox>
      <mat-error *ngIf="invalid && touched" class="checkbox-error">{{ getErrorMessage$() | async | translate }}</mat-error>
    </div>
  `,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class CheckboxFieldComponent extends FormFieldBase implements OnInit {

  ngOnInit(): void {
    const {formControlName} = this.item.settings;
    this.fs.addControl(formControlName, false);
  }

  toggleFromEnter(event: KeyboardEvent | Event): void {
    event.preventDefault();
    const control = this.formGroup.get(this.formName);
    control?.setValue(!control.value);
    this.dataChanged(control?.value);
  }
}
